import { HttpAction } from "@megaron/http-service";
import { syncOperationSerializer, syncResultSerializer } from "@megaron/import-export";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { itemSerializer } from "./items";

export const importItemsOptionsSerializer = Serializers.object({
  googleSheets: Serializers.object({
    spreadsheetId: Serializers.string,
    sheetTitle: Serializers.string.optional(),
    headerMapping: Serializers.record(Serializers.string, Serializers.string).optional(),
    accessToken: Serializers.string.optional(),
  }),
  csv: Serializers.object({
    content: Serializers.string,
    delimiter: Serializers.string,
    headerMapping: Serializers.record(Serializers.string, Serializers.stringOneOf(...itemSerializer.keys)).optional(),
  }),
  json: Serializers.object({
    content: itemSerializer.array(),
  }),
  bc: Serializers.object({}),
  shopify: Serializers.object({}),
  payloadCms: Serializers.object({}),
  importOperations: Serializers.array(syncOperationSerializer(itemSerializer.fields)),
}).partial();

export type ImportItemsOptions = SerializerValue<typeof importItemsOptionsSerializer>;

export const importItemsActions = {
  importItems: HttpAction({
    path: "/items/import",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      dryRun: Serializers.boolean,
      ...importItemsOptionsSerializer.fields,
    }),
    valueSerializer: syncResultSerializer(itemSerializer.fields),
  }),
};
